var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.5a.75.75 0 0 0-.75.75v.787A7.5 7.5 0 0 0 4.5 10.5v1.595a3 3 0 0 1-1.08 2.304l-.343.287a2.298 2.298 0 0 0 1.471 4.064H8.25a3.75 3.75 0 1 0 7.5 0h3.613a2.387 2.387 0 0 0 1.688-4.074l-.672-.672a3 3 0 0 1-.879-2.122V10.5c0-3.89-2.96-7.087-6.75-7.463V2.25A.75.75 0 0 0 12 1.5Zm6 9a6 6 0 0 0-12 0v2.297a3 3 0 0 1-1.08 2.305l-.883.736a.799.799 0 0 0 .511 1.412h14.815a.887.887 0 0 0 .627-1.513l-1.111-1.112A3 3 0 0 1 18 12.504V10.5Zm-3.75 8.25h-4.5a2.25 2.25 0 0 0 4.5 0Z",
    fill: "#fff"
  })));
};

export default SvgBell;